var map = {
	"./arrow-left.svg": [
		2611,
		611
	],
	"./arrow-up.svg": [
		6178,
		178
	],
	"./drag-cursor.svg": [
		3478,
		478
	],
	"./play.svg": [
		9914,
		63
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2873;
module.exports = webpackAsyncContext;